import React from 'react';
import { BASE_URL } from '../constants/config';

const BackgroundView = ({settings}) => {

    console.log("===============================");
    console.log(settings);
    console.log("===============================");

 if (settings.backgroud_type.includes("image")) {
        document.body.style.backgroundImage = `url(${
        BASE_URL + settings.backgroud
      })`;
      document.body.style.backgroundSize = "cover";
      document.body.style.backgroundRepeat = "no-repeat";
     
    }else{
       return (
         <video autoPlay muted loop className="bg-video">
         <source src={BASE_URL + settings.backgroud} type="video/mp4" />
         </video>
       )
    }
};

export default BackgroundView;